module.exports = __webpack_public_path__ + "static/media/first-pos.3a446375.svg";